import React, { ReactNode } from 'react';
import { BackSvgPSP } from '../../svgImages';

interface IHelperAccordion {
  title: string;
  isActive: boolean;
  onClick: () => void;
  children: ReactNode;
}

const HelperAccordion: React.FC<IHelperAccordion> = ({ title, isActive, onClick, children }) => {
  return (
    <div className="accordion-wrapper-psp">
      <span className={`accordion-title-psp ${isActive ? 'open' : 'close'}`} onClick={onClick}>
          {title} <BackSvgPSP fill="white" height={16} />
      </span>
      <div className={`accordion-content-psp ${isActive ? 'active' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default HelperAccordion;